import QuinielaGroupsUI from './QuinielaGroupsUI';
export default  QuinielaGroupsUI;